import { Box, Typography } from "@mui/material";
import React from "react";
interface Prpps {
  text?: string;
  height?: string;
  completeText?: string;
}

const TabsEmptyStyle = ({ text, height = "45vh", completeText }: Prpps) => {
  return (
    <Box
      sx={{
        width: "100%",
        height: { height },
        background: "#F9FCFE",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "10px",
      }}
    >
      <Typography color={"#9AAFC4"} fontSize={"1.2rem"}>
        {!completeText ? (
          <span> موردی به لیست {text} اضافه نشده</span>
        ) : (
          completeText
        )}
      </Typography>
    </Box>
  );
};

export default TabsEmptyStyle;
